<div class="document-page-assignment__header">WORKING PAGES<app-tool-tip
  text={{toolTipMessageForWorkingPages}}>
</app-tool-tip></div>
<ng-template #workingPageRangeColumn let-rowData let-index="index">
    <a href="javascript:void(0)" (click)="goToWorkingDocumentPageClick(rowData,index)">({{rowData.startPage}} -
      {{rowData.endPage}})</a>
</ng-template>
<div *ngIf="!isChartLakeIntake else chartlakeWorkingGrid">
<app-server-grid #gridWorkingPageAssignments [configuration]="workingPageAssignmentsServerGridConfiguration"
  [(request)]="workingPageAssignmentsServerRequest" [refresh]="refreshWorkingPageAssignmentGrid"
  [actions]="workingPageAssignmentsActions" [actionTemplate]="workingPageAssignmentsActionsTemplate"
  (dataLoaded)="workingPageAssignmentsGridDataLoaded($event)" >

  <ng-template #workingChaseIdColumn let-rowData let-index="index">
    <div *ngIf="displayWorkingChaseId(rowData.chaseId,index)" (mouseenter)="projectNamePopover.show($event)" (mouseout)="projectNamePopover.hide()">
      {{rowData.chaseId}}
        <app-popover #projectNamePopover [appendTo]="body">
            <div class="popover-text">{{rowData.projectName}}</div>
        </app-popover>
    </div>
  </ng-template>
  <ng-template #workingPageAssignmentsActionsTemplate let-rowData let-index="index">
    <div class="action-template-container">
      <app-button *ngIf="showWorkingPageAssignmentGotoAction(rowData,index)" text="GO TO" (onClick)="goToWorkingDocumentPageClick(rowData,index)"></app-button>
      <app-button *ngIf="showWorkingPageAssignmentRemoveAction(rowData,index)" text="Remove" (onClick)="workingPageAssignmentRemoveClick(rowData,index)"></app-button>
      <app-button *ngIf="showChangeToIgnoreAction(rowData,index)" text="IGNORE" (onClick)="workingPageAssignmentChangeToIgnoreActionClick(rowData,index)"></app-button>
      <app-button *ngIf="showChangeToChaseAction(rowData,index)" text="CHASE" (onClick)="workingPageAssignmentChangeToChaseActionClick(rowData,index)"></app-button>

    </div>
  </ng-template>

</app-server-grid>
</div>
<ng-template #chartlakeWorkingGrid>
  <app-basic-grid #chartLakeWorkingPageAssignments [configuration]="chartlakeWorkingPageAssignmentGridConfiguration"
   [refresh]="refreshWorkingPageAssignmentGrid"
   [data]="chartlakeWorkingPageGridData"
  [actions]="chartlakeWorkingPageAssignmentActions" [actionTemplate]="chartlakeWorkingPageAssignmentsActionsTemplate"
  >
  <ng-template #chartlakeWorkingPageAssignmentsActionsTemplate let-rowData let-index="index">
    <div class="action-template-container">
      <app-button *ngIf="showWorkingPageAssignmentGotoAction(rowData,index)" text="GO TO" (onClick)="goToWorkingDocumentPageClick(rowData,index)"></app-button>
      <app-button *ngIf="showWorkingPageAssignmentRemoveAction(rowData,index)" text="Remove" (onClick)="workingPageAssignmentRemoveClick(rowData,index)"></app-button>
    </div>
  </ng-template>
  </app-basic-grid>
</ng-template>
<app-modal
  [(visible)]="isClearAllPagesModalVisible"
  header="Clear all working pages"
  (visibleChange)="visibleChange.emit($event)"
  (onShow)="onShow.emit($event)"
  (onHide)="onModalHide()"
  class="commit-modal commitment-date">
  <div class="assignment-item">
    <label>Are you sure you want to clear all working pages from this document? This action cannot be undone.</label>
  </div>
  <footer>
    <app-button
      class="header-button"
      text="SUBMIT"
      (onClick)="removeAllWorkingPagesClick()">
    </app-button>
  </footer>
</app-modal>

<div class="document-page-assignment-buttoncontainer">
<app-button class="document-page-assignment__buttons--commit-chase text-left" text="Clear All Working Pages" *ngIf="!isChartLakeIntake" [disabled]="!hasUncommitedWorkingPageAssignments" (onClick)="showClearAllModal()">
</app-button>
<app-button class="document-page-assignment__buttons--commit-chase text-right" text="{{!isChartLakeIntake ? 'COMMIT CHASE ASSIGNMENTS' : 'COMMIT CHART ASSIGNMENTS'}}" [disabled]="!hasUncommitedWorkingPageAssignments" (onClick)="workingPageAssignmentSubmitAllClick()">
</app-button>
</div>

<div class="document-page-assignment__header">COMMITTED PAGES<app-tool-tip
  text={{committedPagesToolTipMessage}}>
</app-tool-tip></div>
<ng-template #pageRangeColumn let-rowData let-index="index">
    <a href="javascript:void(0)" (click)="goToPageClick(rowData, index)">({{rowData.startPage}} -
      {{rowData.endPage}})</a>
</ng-template>
<div *ngIf="!isChartLakeIntake else chartlakeCommittedGrid">
<app-server-grid #gridPageAssignments [configuration]="pageAssignmentsServerGridConfiguration"
  [(request)]="pageAssignmentsServerRequest" [refresh]="refreshPageAssignmentGrid"
  [actionTemplate]="pageAssignmentsActionsTemplate" (dataLoaded)="pageAssignmentsGridDataLoaded($event)"
  [isLoadOnInit]="true">

  <ng-template #chaseIdColumn let-rowData let-index="index">  
    <div (mouseenter)="projectNamePopover.show($event)" (mouseout)="projectNamePopover.hide()">
      {{rowData.chaseId}}
        <app-popover #projectNamePopover [appendTo]="body">
            <div class="popover-text">{{rowData.projectName}}</div>
        </app-popover>
    </div>
  </ng-template>
  <ng-template #pageAssignmentsActionsTemplate let-rowData let-index="index">
    <div class="action-template-container">
      <app-button *ngIf="showWorkingPageAssignmentGotoAction(rowData)" text="GO TO" (onClick)="goToPageClick(rowData,index)"></app-button>
      <app-button *ngIf="showPageAssignmentRemoveAction(rowData)" text="Remove" (onClick)="pageAssignmentRemoveClick(rowData,index)"></app-button>
      <app-button *ngIf="showViewInvoiceAction(rowData)" text="View Invoice" (onClick)="viewInvoiceClick(rowData)"></app-button>
     </div>
  </ng-template>

</app-server-grid>
</div>
<ng-template #chartlakeCommittedGrid>
  <app-basic-grid #chartLakeCommittedPageAssignments [configuration]="chartlakeCommittedPageAssignmentGridConfiguration"
  [data]="chartlakeCommittedPageAssignments" [refresh]="refreshPageAssignmentGrid"
  [actionTemplate]="chartLakePageAssignmentsActionsTemplate">
  <ng-template #chartLakePageAssignmentsActionsTemplate let-rowData let-index="index">
    <div class="action-template-container">
      <app-button *ngIf="showWorkingPageAssignmentGotoAction(rowData)" text="GO TO" (onClick)="goToPageClick(rowData,index)"></app-button>
    </div>
  </ng-template>
  </app-basic-grid>
</ng-template>
<app-confirmation-modal #confirmationForInActiveChases [(visible)]="showConfirmationForInActiveChases"
  header="ATTENTION" acceptText="YES" rejectText="NO">
  {{confirmationTextForAttachingToInactiveChase}}
</app-confirmation-modal>
<app-confirmation-modal #confirmationForActiveChases [(visible)]="showConfirmationForActiveChases" header="ATTENTION"
  acceptText="CONTINUE" rejectText="NO">
  {{confirmationTextForAttachingToActiveChase}}

</app-confirmation-modal>
<app-modal #notAllowedModal [(visible)]="showNotAllowedModal" header="NOT ALLOWED">
  <div>{{attachChaseNotAllowedMsg}}</div>
</app-modal>
<app-confirmation-modal #confirmationForRemoveChase [(visible)]="showConfirmationForRemoveChase" header="ATTENTION"
                        acceptText="REMOVE" rejectText="NO"
                        (onYes)="removeCommittedPageAssignment()"
                        (onCancel)="cancelRemoveCommittedPageAssignment()"
                        >
  {{confirmationTextForRemoveChase}}

</app-confirmation-modal>
